import { Action } from '@ngrx/store';
import { DiagnosticoData } from '../models/store.model';

export const SETDIAGNOSTICODATA = '[DiagnosticoData] Set Diagnostico Data';
export const UNSETDIAGNOSTICODATA = '[DiagnosticoData] Unset Diagnostico Data';

export class SetDiagnosticoData implements Action {
    readonly type = SETDIAGNOSTICODATA;
    constructor(public diagnostico: DiagnosticoData) { }
}

export class UnsetDiagnosticoData implements Action {
    readonly type = UNSETDIAGNOSTICODATA;
}

export type DiagnosticoDataActions =
    | SetDiagnosticoData
    | UnsetDiagnosticoData;
